import { useState, useEffect } from 'react'
import { Table, Typography, Tooltip } from 'antd'
import { getAccessTokenCheaters } from 'src/api/reports'
import { isoToTimestamp } from 'src/utils/timestamp'
const { Title, Text } = Typography

const AccessToken = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [totalRecords, setTotalRecords] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const fetchCheater = async (page, size) => {
    setLoading(true)
    try {
      const res = await getAccessTokenCheaters(page - 1, size)
      console.log('getAccessTokenCheaters : ', res)
      const mapped = res.data.map((item) => ({
        key: item.userId,
        ...item,
      }))
      setTotalRecords(res.total_items)

      setData(mapped)
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    {
      title: 'User Id',
      dataIndex: 'userId',
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
    },
    {
      title: 'Info',
      dataIndex: 'info',

      render: (text) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: 'Date',
      dataIndex: 'createdAt',
      render: (text) => {
        return isoToTimestamp(text)
      },
    },
  ]

  const handleTableChange = (pagination: any) => {
    setData([])
    setCurrentPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  useEffect(() => {
    fetchCheater(currentPage, pageSize)
  }, [currentPage, pageSize])

  return (
    <div>
      <Title level={4} style={{ color: '#fff' }}>
        Cheaters Access Token
      </Title>

      <Table
        style={{ marginTop: 20 }}
        loading={loading}
        columns={columns}
        dataSource={data}
        scroll={{ x: 1000 }}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '25', '50', '100'],
          total: totalRecords,
        }}
        onChange={handleTableChange}
      />
    </div>
  )
}
export default AccessToken
